(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("everyAF", [], factory);
	else if(typeof exports === 'object')
		exports["everyAF"] = factory();
	else
		root["everyAF"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 